<template>
  <div class="app-main">
    <!-- <header class="header"></header> -->
    <div name="fade" mode="out-in">
      <div class="default-view">
        <router-view class="operation-view"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AppMain',
  data () {
    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    }
  },
  computed: {
    cachedViews () {
      return ['model'] // read from state
    },
    ...mapGetters(['menuList', 'userInfo']),
    rootList () {
      return this.menuList.map(item => ({ name: item.name, key: item.key }))
    },
    userMenuList () {
      // console.log('用户信息', this.userInfo);
      let reList = JSON.parse(JSON.stringify(this.menuList));
      for (let i = 0; i < reList.length; i++) {
        if (!this.userInfo.menus.includes(reList[i].key)) {
          reList.splice(i, 1);
          i--;
        } else {
          if (reList[i].children && reList[i].children.length > 0) {
            for (let j = 0; j < reList[i].children.length; j++) {
              if (!this.userInfo.menus.includes(reList[i].children[j].key)) {
                reList[i].children.splice(j, 1);
                j--;
              }
            }
          }
        }
      }
      return reList;
    }
  },
  methods: {
    handleNodeClick (menuItem, childItem) {
      if (childItem) {
        this.$router.push({ name: childItem.key })
      }
      // if (!node.children && this.$route.name !== node.key) {
      //    this.$router.push({ name: node.key })
      // }
    },
    filterNode (value, data) {
        return this.userInfo.menus.includes(data.key);
      }
  },
  mounted () {
  }
}
</script>

<style scoped lang="less">
@import "~@/styles/variables.less";
.app-main {
  width: 100%;
  height: 100%;
  background-color: rgba(171, 31, 31, 0);

  .header {
    width: 100%;
    height: 80 * @uh;
  }
  .default-view {
    // position: absolute;
    top: 0;
    width: 100%;
    // height: 100%;
    z-index: 100;
    pointer-events:none;

    .menu-tree {
      pointer-events: all;
      width: 291.5 * @uw ;
      height: 1000 * @uh;
      position: absolute;
      // left: 18 * @uw;
      top: 70 * @uh;
      // padding: 40 * @uh 22 * @uw;
      background: rgb(246, 246, 246);
      // background-image: url('~@/assets/left-panel-bg.png');
      // background-size: 100% 100%;
      // .menuTitle {
      //   font-size: 18 * @uw;
      // }
      .menuIcon {
        margin-right: 10 * @uw;
      }
      .firstMenu {
        font-size: 18 * @uw;
        font-family: SourceHanSerifCN-Heavy;
        // color: rgb(13, 91, 236);
      }
      /deep/ .el-submenu__title {
        font-size: 16 * @uw;
      }
      .icon-img {
        width: 14 * @cm;
        height: 14 * @cm;
        margin-right: 32 * @uw;
      }
      /deep/ .el-menu {
        height: 100%;
        overflow-y: auto;
      }
      // /deep/ .el-tree {
      //   // background-color: rgba(0,0,0,0);
      //   // color: white;
      // }
      // /deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
      //     // background-image: url('~@/assets/images/menu/menu-bg.png');
      //     background-size: 100% 100%;
      //     font-weight: bold;
      //     // background-color: rgba(0,0,0,0);
      //   }
      // /deep/ .el-tree-node__content {
      //   height: 36 * @cm;
      //   &:hover{
      //     // background-color: rgba(0,0,0,0.2);
      //   }
      // }
    }
    .operation-view {
      // position: absolute;
      left: 0 * @uw;
      top: 0 * @uh;
      // height: 70 * @uh;
      width: 1920 * @uw;
      height: 1080 * @uh;
      pointer-events: all;
      // background: yellow;
    }
  }
}
</style>
